import { render, staticRenderFns } from "./Sent.vue?vue&type=template&id=6928204b&scoped=true&"
import script from "./Sent.vue?vue&type=script&lang=js&"
export * from "./Sent.vue?vue&type=script&lang=js&"
import style0 from "./Sent.vue?vue&type=style&index=0&id=6928204b&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6928204b",
  null
  
)

export default component.exports